import React from "react";
import ValidationsMessage from "./ValidationsMessage";

const FormInput = ({
  id,
  label,
  value,
  onChangeHandler,
  validationMessage,
  isSubmit,
  inputRef,
  type = "text",
  maxLength = 100,
}) => (
  <div className="form-group">
    <label htmlFor={id}>{label}</label>
    <input
      ref={inputRef}
      id={id}
      type={type}
      maxLength={maxLength}
      className="form-control"
      value={value}
      onChange={onChangeHandler}
    />
    <ValidationsMessage
      field={value}
      isSubmit={isSubmit}
      message={validationMessage}
    />
  </div>
);

export default FormInput;
